import React, { Component } from 'react';
import PropTypes from 'prop-types';
// common components
import PageHeader from './../../common/PageHeader/PageHeader';
import CustomDrawer from './../../common/CustomDrawer/CustomDrawer';
import Modal from './../../common/Modal/Modal';
import Pagination from './../../common/Pagination/Pagination';
import Dropzone from './../../common/Dropzone/Dropzone';
// components
import BatchDetails from './BatchDetails/BatchDetails';
import ParticipantList from './ParticipantList/ParticipantList';
import ManageParticipant from './ManageParticipant/ManageParticipant';
import ManageUser from './../User/ManageUser/ManageUser';
import ParticipantTable from './ParticipantList/ParticipantTable';

class BatchParticipant extends Component {
	constructor(props) {
		super(props);
		this.state = {
			bulkUploadModal: false,
			toggleView: true,
			userModal: false,
			batchId: this.props.match.params.batch_id,
			drawerOpen: false,
			title: '',
			partArray: [],
			file: null,
			currentUserId: '',
			breadcrumb: [
				{
					name: 'Batch',
					url: '/batch',
					fn: () => this.props.history.go(-1)
				}
			],
			userDetails: {
				firstname: '',
				lastname: '',
				email: '',
				phone: '',
				country: '',
				city: ''
			},
			errorUserDetails: {
				firstname: true,
				lastname: true,
				email: true
			}
		}
		this.manageUser = this.manageUser.bind(this);
		this.confirmUserAction = this.confirmUserAction.bind(this);
		this.onChange = this.onChange.bind(this);
		this.bulkUpload = this.bulkUpload.bind(this);
		this.onUpload = this.onUpload.bind(this);
		// this.manageParticipant = this.manageParticipant.bind(this);
		// this.onToogleCheck = this.onToogleCheck.bind(this);
		// this.batchPartUpdate = this.batchPartUpdate.bind(this);
	}

	componentDidMount() {
		const { batchId } = this.state;
        const { batchContext, batchPartContext} = this.props;

        batchContext.getBatchDetails(batchId);
        batchPartContext.getBatchPartList(batchId, 1, 25);
        // userContext.getUserList();
	}

	componentWillUnmount() {
        const { commonContext, batchPartContext} = this.props;
		batchPartContext.clearBatchPartList();
    	commonContext.updatePagination();
		commonContext.updateLoaderMsg();
	}
	
	// open Modal (user_module)
	manageUser = (value, title = null,id=null) => {
		if (!value) {
			this.setState({
				userDetails: {
					firstname: '',
					lastname: '',
					email: '',
					phone: '',
					country: '',
					city: ''
				},
				errorUserDetails: {
					firstname: true,
					lastname: true,
					email: true
				}
			});
		}
		if(value) {
			if(title == 'delete') {
				this.setState({ currentUserId: id });
			}
		} 
		this.setState({
			userModal: value,
			title
		});
	}

	confirmUserAction = () => {
		const { title, userDetails, batchId, currentUserId } = this.state;
		const { addUser, deleteBatchPart } = this.props.batchPartContext;

		if (title === 'add') {
			addUser(userDetails, batchId);
		}else if(title === 'delete'){
			deleteBatchPart(currentUserId, batchId);
		}
	}

	onChange = (e, val) => {
		this.setState({
			userDetails: {
				...this.state.userDetails,
				[e.target.name]: e.target.value
			},
			errorUserDetails: {
				...this.state.errorUserDetails,
				[e.target.name]: val
			}
		});
	}

	onDisable = (ers) => {
        const value = Object.keys(ers).some(val => ers[val] === true);
        return value;
    }

    onToggle = () => {
		this.setState({
			...this.state,
			toggleView: !this.state.toggleView
		});
	}

	// pagination
	onChangePage = (curr_page, size) => {
		this.props.batchPartContext.getBatchPartList(this.state.batchId, curr_page, size);
	}

	bulkUpload = (val = false) => {
		this.setState({ bulkUploadModal: val });
	}

	onUpload = (file) => {
		this.setState({ file });
	}

	// manageParticipant(value,title) {
	// 	if(value) {

	// 	} else {
	// 		this.setState({
	// 			partArray: []
 //            });
	// 	}
 //        this.setState({ drawerOpen: value, title });
	// };

	// onToogleCheck(id, val) {
	// 	if(val) {
	// 		this.state.partArray.push(id);
	// 	} else {
	// 		var index = this.state.partArray.indexOf(id);
	// 		this.state.partArray.splice(index, 1);
	// 	}
	// }

	 // confirm button
	//  batchPartUpdate = () => {
 //        const { title, partArray, batchId } = this.state;
 //        const { deleteBatchPart } = this.props.batchPartContext;

 //       if (title === 'add') {
	// 		// addBatchPart(partArray, batchId);
 //        } else if (title === 'delete') {
	// 		deleteBatchPart(partArray, batchId);
 //        }
	// }
	
	render () {
		const { batchDetails } = this.props.batchContext;
		const { batchPartList, deleteBatchPart, partBulkUpload } = this.props.batchPartContext;
		const { pagination } = this.props.commonContext;
		// const { userList } = this.props.userContext;
		const { breadcrumb, drawerOpen, title, batchId, userDetails, userModal, bulkUploadModal, file} = this.state;

		return (
			<div className='BatchParticipant'>

				<BatchDetails
					batchDetails={batchDetails}
					links={breadcrumb}
					partLength={pagination && pagination.numberOfElements ? pagination.numberOfElements : batchPartList.length}
				/>

				<PageHeader
					title='participants'
					btnText='participant'
					onAdd={() => this.manageUser(true, 'add')}
					isToggle
					bulkUpload={() => this.bulkUpload(true)}
					toggleValue={this.state.toggleView}
					onToggle={() => this.onToggle()}
				/>

				{this.state.toggleView ? (
					<ParticipantTable
						batchPartList={batchPartList}
						// deleteBatchPart={(userid) => deleteBatchPart(userid, batchId)}
						manageUser={this.manageUser}
					/>
				) : (
					<ParticipantList
						batchPartList={batchPartList}
						// deleteBatchPart={(userid) => deleteBatchPart(userid, batchId)}
						manageUser={this.manageUser}
					/>
				)}

				{pagination && pagination.totalElements > 0 &&
					<Pagination
						totalPage={pagination.totalPages}
						onChangePage={this.onChangePage}
						count={pagination.totalElements}
						first={pagination.first}
						last={pagination.last}
					/>
				}

				{/* Add, Edit, and delete Participant Modal */}
					{/*<CustomDrawer
						drawerOpen={drawerOpen}
						toggleDrawer={this.manageParticipant}
						title={title}
						confirm={() => this.batchPartUpdate()}
					>
						<ManageParticipant
							title={title}
							userList={userList}
							onToogleCheck={this.onToogleCheck}
							batchPartList={batchPartList}
						/>
					</CustomDrawer>*/}
				{/* Add, Edit, and delete Participant Modal */}
				{/* Add, Edit, and delete user */}
				{userModal &&
					<Modal
						modalOpen={userModal}
						toggleModal={this.manageUser}
						title={title}
						disabled={title !== 'delete' && this.onDisable(this.state.errorUserDetails)}
						confirm={this.confirmUserAction}
					>
						<ManageUser
							onDelete={title === 'delete'}
							userDetails={userDetails}
							onChange={(e, val) => this.onChange(e, val)}
						/>
					</Modal>
				}
				{/* bulk upload */}
				{bulkUploadModal &&
					<Modal
						modalOpen={bulkUploadModal}
						toggleModal={this.bulkUpload}
						title="Bulk Upload"
						disabled={!file}
						confirm={() => partBulkUpload(file, batchId)}
					>
						<div>
							{/*<input
								name="file"
								type="file"
								placeholder="Upload a CSV file"
								// value={file}
								onChange={this.onUpload}
								autoFocus
		                        accept=".csv"
							/>*/}
							<Dropzone
								name="file"
								alertMsg="Please upload only .csv file"
								onUpload={this.onUpload}
							/>
						</div>
					</Modal>
				}
				{/* bulk upload */}
			</div>
		);
	}
}

BatchParticipant.propTypes = {
	history: PropTypes.instanceOf(Object),
	match: PropTypes.instanceOf(Object),
	batchContext: PropTypes.instanceOf(Object),
	batchPartContext: PropTypes.instanceOf(Object) 
};

BatchParticipant.defaultProps = {
	history: {},
	match: {},
	batchContext: {},
	batchPartContext: {}   
};

export default BatchParticipant;



// WEBPACK FOOTER //
// ./components/BatchParticipant/BatchParticipant.js